import { Route } from '@angular/router';
import { Error404Component } from './../error-404/error-404.component';

export const error404Routes: Route[] = [
    {
        path     : 'error-404',
        component: Error404Component
    }
];
